function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 12,
  width: 25,
  height: 18,
  rx: 4,
  fill: "url(#cards_svg__cards0_linear)",
  fillOpacity: 0.9
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 2,
  width: 25,
  height: 18,
  rx: 4,
  fill: "url(#cards_svg__cards1_linear)",
  fillOpacity: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "cards_svg__cards0_linear",
  x1: 0,
  y1: 30,
  x2: 26.624,
  y2: 14.854,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B66EFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#93C2FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cards_svg__cards1_linear",
  x1: 7,
  y1: 20,
  x2: 33.624,
  y2: 4.854,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F1E1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#97C5FF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "cards_svg__filter0_b",
  x: 1,
  y: -4,
  width: 37,
  height: 30,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMTIiIHdpZHRoPSIyNSIgaGVpZ2h0PSIxOCIgcng9IjQiIGZpbGw9InVybCgjY2FyZHMwX2xpbmVhcikiIGZpbGwtb3BhY2l0eT0iMC45Ii8+CjxnPgo8cmVjdCB4PSI3IiB5PSIyIiB3aWR0aD0iMjUiIGhlaWdodD0iMTgiIHJ4PSI0IiBmaWxsPSJ1cmwoI2NhcmRzMV9saW5lYXIpIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2IiIHg9IjEiIHk9Ii00IiB3aWR0aD0iMzciIGhlaWdodD0iMzAiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlR2F1c3NpYW5CbHVyIGluPSJCYWNrZ3JvdW5kSW1hZ2UiIHN0ZERldmlhdGlvbj0iMyIvPgo8ZmVDb21wb3NpdGUgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9ImluIiByZXN1bHQ9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXIiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyIiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8bGluZWFyR3JhZGllbnQgaWQ9ImNhcmRzMF9saW5lYXIiIHgxPSIzLjcyNTI5ZS0wNyIgeTE9IjMwIiB4Mj0iMjYuNjIzNyIgeTI9IjE0Ljg1NDEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0I2NkVGQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5M0MyRkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJjYXJkczFfbGluZWFyIiB4MT0iNyIgeTE9IjIwIiB4Mj0iMzMuNjIzNyIgeTI9IjQuODU0MDkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0YxRTFGRiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5N0M1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgCards as ReactComponent };